import styled from "styled-components";

export const TechnologiesContainer = styled.section`
  background-color: ${({ theme }) => theme.backgroundColor.dark};
  color: ${({ theme }) => theme.color.light};
`;

export const TechnologiesHeader = styled.h2`
  text-align: center;
  font-weight: 700;
`;

export const TechnologiesIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 3rem;
  
  @media all and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    gap: 1.25rem;
    margin-top: 2.5rem;
  }
`;

export const TechnologyIcon = styled.img`
  height: 32px;

  @media all and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 24px;
  }
  
  @media all and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 28px;
  }
`;
